import { createRequestData, searchRequestData, updateRequestData } from '../../Utility/apiHelper';
import { handleValidateCodevalue } from '../../Utility/constant';
import { requestHideLoader, requestShowLoader } from '../Global/action';
import * as actionTypes from './type';


export const getAllDocuments =(queryparams,url)=> async(dispatch)=>{
    dispatch({
        type: actionTypes.REQUEST_GET_ALL_DOCUMENTS,
    })
    const response = await searchRequestData(queryparams,url)
    if(response?.status === 200){
    dispatch({
        type: actionTypes.RECEIVED_ALL_DOCUMENTS,
        payload : response?.data
    })
    }
    else{
    dispatch({
       type : actionTypes.RECEIVED_ERROR,
       payload : response?.propererror?.data?.message
    })
    }
}

export const removeAllDocuments =()=> async(dispatch)=>{
dispatch({
        type: actionTypes.REMOVE_ALL_DOCUMENTS,
        payload : []
    })
}


export const requestAddDocument =(formData,url,enqueueSnackbar,internationalise, onSuccess)=> async(dispatch)=>{

    dispatch(requestShowLoader())
    dispatch({
        type: actionTypes.REQUEST_UPLOAD_DOCUMENT,
    })
    
        const response = await createRequestData(formData, url , true);
    if(response?.status === 200){
    dispatch({
        type: actionTypes.DOCUMENT_UPLOADED_SUCCESSFULLY,
        payload : response?.data
    })
    enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPLOADED_SUCCESSFULLY"),{variant:'success'})
    if (onSuccess) onSuccess();
}else{
    dispatch({
       type : actionTypes.RECEIVED_ERROR,
       error : response?.propererror?.data?.message
    })
    enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"),{variant:'error'})
}
    dispatch(requestHideLoader())
}


export const requestUpdateDocument =(reqData,url,enqueueSnackbar,internationalise, onSuccess)=> async(dispatch)=>{
    
    dispatch(requestShowLoader())
    dispatch({
        type: actionTypes.REQUEST_UPDATE_DOCUMENT,
    })
    
    const response =  await updateRequestData(reqData,url)
    if(response?.status === 200){
    dispatch({
        type: actionTypes.DOCUMENT_UPDATED_SUCCESSFULLY,
    })
    enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPDATED_SUCCESSFULLY"),{variant:'success'})
    if (onSuccess) onSuccess();
}
else{
    dispatch({
       type : actionTypes.RECEIVED_ERROR,
       error : response?.propererror?.data?.message
    })
    enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"),{variant:'error'})
}

    dispatch(requestHideLoader())
}